function setThemeMode(body, mode) {
  body.classList.remove('light-mode', 'dark-mode')
  body.classList.add(`${mode}-mode`)
}

function syncThemeToSession(mode) {
  fetch('/theme_mode', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
    },
    body: JSON.stringify({ mode }),
  })
}

document.addEventListener('turbo:load', () => {
  const select = document.getElementById('theme-select')
  const body = document.body

  if (!select) return

  const savedTheme = localStorage.getItem('theme') || 'light'
  select.value = savedTheme

  // Sync localStorage preference to session if it differs from server-rendered class
  if (!body.classList.contains(`${savedTheme}-mode`)) {
    setThemeMode(body, savedTheme)
    syncThemeToSession(savedTheme)
  }

  select.addEventListener('change', (e) => {
    const theme = e.target.value
    localStorage.setItem('theme', theme)
    setThemeMode(body, theme)
    syncThemeToSession(theme)
  })
})
